import {
    Button,
    H2,
    HEADER_TEXT_SIZE,
    Text,
    TEXT_WEIGHT,
    UI_KIT_TEXT_TYPOGRAPHY,
    useRouterPath,
    useStaticUrls,
    Link,
    Image,
} from 'platform-components';
import qs from 'query-string';
import React from 'react';
import { useHistory } from 'react-router';

interface Props {
    classId: string | undefined;
}

export const EmptyState = ({ classId }: Props) => {
    const { labLibraryTeamMain, labLibraryMain } = useStaticUrls();
    const history = useHistory();

    const path = classId ? labLibraryTeamMain : labLibraryMain;
    const linkToMainWithCourses = useRouterPath(path);

    const query = qs.parse(history.location.search);

    return (
        <div className="course-container-list">
            <div className="course-container-list__empty-banner">
                <H2
                    id="courseContainerList.emptyStateTitle"
                    mix="course-container-list__empty-title"
                    size={HEADER_TEXT_SIZE.M}
                    weight={TEXT_WEIGHT.M}
                />

                <Link
                    isRouter={true}
                    to={`${linkToMainWithCourses}?${qs.stringify({ ...query, anchor: 'course_container' })}`}
                >
                    <Button className="course-container-list__empty-button">
                        <Text
                            id="courseContainerList.emptyStateButton"
                            typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphMMedium}
                        />
                    </Button>
                </Link>

                <Image
                    alt=""
                    className="course-container-list__empty-img"
                    src="https://avatars.mds.yandex.net/get-schoolbook-images/5623482/EemPykwfrfcPY6tgfi8sB/orig"
                />
            </div>
        </div>
    );
};
